import * as _RRule from "rrule";

/*
 * Spooky Library!
 * RRule is a library that has incorrectly implemented (or at least weirdly implmeneted
 * it's es-module support. This means that depending on whether you are using commonJS\
 * or an esmodule, it imports differently.
 *
 * The basic thing is that if you are running cjs, it imports as an object containing it's
 * children (RRule, RRuleSet, etc.). If you are running an esmodule, it loads as a module
 * with it's children in "default".
 *
 * This was the way I managed to get it to work, use this intead of importing RRule directly
 */

// Bracket access avoids Rollup special-casing `.default`; rrule is CJS and bundlers may expose its exports under a synthetic `default` property.
const rruleDefault = (_RRule as unknown as { default?: typeof _RRule })["default"];

export const RRule = _RRule.RRule ?? rruleDefault?.RRule;
export const rrulestr = _RRule.rrulestr ?? rruleDefault?.rrulestr;
export const Frequency = _RRule.Frequency ?? rruleDefault?.Frequency;

export type RRuleType = _RRule.RRule;

export type RRuleSetType = _RRule.RRuleSet;
